
import { baseUrl } from "../../constants";
import { getDDAgencyCall } from "../../redux/actions/dropDown";

export default {
    "formTitle": "Add Client Group",
    "tableTitle": " Client Group List",
    "apiDetails": {
        startUp: (dispatch) => {
            dispatch(getDDAgencyCall());
        },
        list: {
            url: `${baseUrl}/api/agency/client_group/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "clientGrp"
            }
        },
        add: `${baseUrl}/api/agency/client_group`,
        edit: `${baseUrl}/api/agency/client_group/edit`,
        delete: `${baseUrl}/api/agency/client_group/remove`
    },
    "tableCol": [
        {
            name: 'Client Group',
            selector: row => row.clientGrp,
            sortable: true
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true
        },
        {
            name: 'Agency',
            selector: row => row.agency,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    "type": "select",
                    "label": "Agency",
                    "name": "agency",
                    "options": [
                        "Gateway",
                        "Quixlab"
                    ],
                    "required": true
                }
            ]
        },
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Client Group',
                    name: 'clientGrp',
                    required: true
                }
            ]
        },
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'textArea',
                    label: 'Description',
                    name: 'description',
                    required: true
                }
            ]
        }
    ],
    "mockData": [{
        "agency": "Quixlab",
        "clientGrp": "dgdg",
        "description": "3434 dgg"
    }]
}